// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__BLSyR","button":"styles_button__6IyVp","text-area":"styles_text-area__LG3mJ"};